import React from 'react';
import { Box, Typography } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import TableChartIcon from '@mui/icons-material/TableChart';
import { CustomButton } from '../../Infra/CustomButton/CustomButton';
import { StepHeaderProps } from './types';
import styles from './StepHeader.module.scss';

export const StepHeader: React.FC<StepHeaderProps> = ({
  title,
  subtitle,
  icon,
  onShowFeed,
  showFeedEnabled = false,
  showFeedLoading = false,
  onExpandConfiguration,
}) => {
  return (
    <Box className={styles.stepHeader}>
      <Box className={styles.leftContent}>
        {icon && <Box className={styles.icon}>{icon}</Box>}
        <Box className={styles.textContent}>
          <Typography className={styles.title}>{title}</Typography>
          <Typography className={styles.subtitle}>{subtitle}</Typography>
        </Box>
      </Box>
      <Box className={styles.rightContent} sx={{ display: 'flex', gap: 2 }}>
        {onExpandConfiguration && (
          <CustomButton
            variant="outlined"
            onClick={onExpandConfiguration}
            startIcon={<SettingsIcon />}
          >
            Configuration
          </CustomButton>
        )}
        {onShowFeed && (
          <CustomButton
            variant="outlined"
            onClick={onShowFeed}
            disabled={!showFeedEnabled || showFeedLoading}
            loading={showFeedLoading}
            startIcon={<TableChartIcon />}
            data-testid="btn-show-feed"
          >
            Feed
          </CustomButton>
        )}
      </Box>
    </Box>
  );
};
